import React from "react";
import { Redirect } from "react-router-dom"
import {ACCESS_TOKEN} from '../../api/auth.js'

export default class PageBase extends React.Component {

    redirectLogin(to_url, render){
        if (window.localStorage.getItem(ACCESS_TOKEN) == null){
            return <Redirect to={to_url}/>;
        }else{
            return render;
        }
    }
}


